import { render } from "./Mashairi.vue?vue&type=template&id=12e1207a&scoped=true"
import script from "./Mashairi.vue?vue&type=script&lang=js"
export * from "./Mashairi.vue?vue&type=script&lang=js"

import "./Mashairi.vue?vue&type=style&index=0&id=12e1207a&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e1207a"]])

export default __exports__